module.exports = __webpack_public_path__ + "img/template-1-mobile.810d53d0.png";